import { Component, Prop, Vue } from 'vue-property-decorator'
const img = require.context('../assets', true, /^\.\/user-img/)
@Component
export default class UserImg extends Vue {
  @Prop() userImg !: number

  render () {
    let src = img(img.keys()[this.userImg - 1])
    return (<img src={src} alt=""/>)
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("E:\\project\\html\\the-f2e-w7-chatting-room\\node_modules\\vue-jsx-hot-loader\\src\\api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-152b15a2/UserImg.tsx" });